import { DepositLimitPeriod } from "@obg/ngx.core";

import { PeriodOption } from "./deposit-limit.model";

export const NO_LIMIT: PeriodOption = { key: "deposit-limit.limit.option.nolimit", value: DepositLimitPeriod.NoLimit };

export const PERIOD_OPTIONS: PeriodOption[] = [
	{
		key: "deposit-limit.limit.option.daily",
		value: DepositLimitPeriod.Daily,
	},
	{
		key: "deposit-limit.limit.option.weekly",
		value: DepositLimitPeriod.Weekly,
	},
	{
		key: "deposit-limit.limit.option.monthly",
		value: DepositLimitPeriod.Monthly,
	},
];

export const AAMS_PERIOD_OPTIONS: PeriodOption[] = [
	{
		key: "deposit-limit.limit.option.daily",
		value: DepositLimitPeriod.Daily,
	},
	{
		key: "deposit-limit.limit.option.weekly",
		value: DepositLimitPeriod.Weekly,
	},
	{
		key: "deposit-limit.limit.option.monthly",
		value: DepositLimitPeriod.Monthly,
	},
	{
		key: "deposit-limit.limit.option.yearly",
		value: DepositLimitPeriod.Yearly,
	},
];
